import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

// store
import { useStoreValue, storeSet } from '../../../../../../store';

// components
import UserAvatar from '../../../../../../components/UserAvatar';
import { __ } from '@wordpress/i18n';

const UserTopBarMenu = () => {
    const userData = useStoreValue('userData');
    const navigate = useNavigate();
    const fullName = `${userData?.name ?? ''} ${userData?.surname ?? ''}`;
    const profession = userData?.profession ?? ''

    const [showDropdown, setShowDropdown] = useState(false);
    const refContainer = useRef(null);

    const toggleDropdown = () => {
        setShowDropdown(prev => !prev);
    };

    const goToProfile = () => {
        navigate('/profile');
        toggleDropdown();
    }

    const handleLogout = () => {
        setShowDropdown(false);
        storeSet('doLogout');
        navigate('/login', { replace: true });
    };

    const handleKeyDown = (e) => {
        if (e.keyCode === 13 || e.keyCode === 32) {
            e.preventDefault();
            toggleDropdown();
        }
    };

    useEffect(() => {
        if (!showDropdown) return;

        const handleClickOutside = (e) => {
            if (refContainer.current && !refContainer.current.contains(e.target)) {
                setShowDropdown(false);
            }
        };

        const handleEscKey = (e) => {
            if (e.keyCode === 27) {
                e.stopPropagation();
                setShowDropdown(false);
            }
        };

        window.addEventListener('click', handleClickOutside);
        window.addEventListener('keydown', handleEscKey, false);

        return () => {
            window.removeEventListener('click', handleClickOutside);
            window.removeEventListener('keydown', handleEscKey, false);
        };
    }, [showDropdown]);

    return(
        <div className="userTopBarMenu" ref={refContainer}>
            <button
                className="topBar__button"
                type="button"
                onClick={toggleDropdown}
                onKeyDown={handleKeyDown}
                aria-expanded={showDropdown}
                aria-haspopup="true"
            >
                <div className="userTopBarMenu__info">
                    <span className="userTopBarMenu__name">{fullName}</span>
                    <span className="userTopBarMenu__role">{profession}</span>
                </div>
                <UserAvatar url={userData?.profile_picture_url ?? ''} name={fullName}/>
            </button>

            {showDropdown && (
                <div className="userTopBarMenu__dropdown">
                    <ul className="userTopBarMenu__menu">
                        <li>
                            <button
                                className="userTopBarMenu__menuItem"
                                onClick={goToProfile}
                                type="button"
                            >
                                {__('Profilo', 'soundbetween')}
                            </button>
                        </li>
                        <li>
                            <button
                                className="userTopBarMenu__menuItem"
                                onClick={handleLogout}
                                type="button"
                            >
                                Logout
                            </button>
                        </li>
                    </ul>
                </div>
            )}
        </div>
    )
}

export default UserTopBarMenu;